import React from 'react';
import { TextInput as RaTextInput, TextInputProps } from 'react-admin';
import InputAdornment from '@mui/material/InputAdornment';

const TextInput = ({
  popups = null,
  ...props
} : TextInputProps & { popups?: React.ReactNode }) => (
  <RaTextInput
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    sx={{ '& .MuiFilledInput-root': { padding: 0 } }}
    slotProps={{
      input: {
        endAdornment: <InputAdornment position="end">{popups}</InputAdornment>,
      },
    }}
  />
);

export default TextInput;
